import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockReviews } from '../data/mock';

export const Reviews = () => {
  return (
    <section id="recensioni" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Cosa Dicono i Nostri Clienti
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-6">
            La soddisfazione dei nostri clienti è il nostro miglior biglietto da visita
          </p>
          <a 
            href="https://www.google.com/search?q=idromo+italia" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition-colors"
          >
            Vedi tutte le recensioni su Google
            <ExternalLink className="w-4 h-4 ml-2" />
          </a>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {mockReviews.map((review) => (
            <Card key={review.id} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-bold text-gray-900 text-lg">{review.name}</h3>
                    <p className="text-sm text-gray-500">{review.date}</p>
                  </div>
                  <div className="flex">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-orange-400 text-orange-400" />
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed">{review.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Rating Summary */}
        <div className="bg-gradient-to-r from-blue-50 to-orange-50 rounded-2xl p-8 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
            <div>
              <div className="text-6xl font-bold text-gray-900 mb-2">5.0</div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-6 h-6 fill-orange-400 text-orange-400" />
                ))}
              </div>
              <p className="text-gray-600 font-medium">Valutazione Google</p>
            </div>
            <div className="h-16 w-px bg-gray-300 hidden sm:block"></div>
            <div className="text-left">
              <p className="text-3xl font-bold text-gray-900 mb-1">98%</p>
              <p className="text-gray-600">Clienti Soddisfatti</p>
            </div>
            <div className="h-16 w-px bg-gray-300 hidden sm:block"></div>
            <div className="text-left">
              <p className="text-3xl font-bold text-gray-900 mb-1">500+</p>
              <p className="text-gray-600">Recensioni Positive</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
